// /src/pages/private/members/academyTools/components/AcademyDocumentModal.jsx

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import MemberAcademyDocumentPanel from './MemberAcademyDocumentPanel';

export default function AcademyDocumentModal({ show, selectedDocument, onClose }) {
  const portalTarget =
    typeof window !== 'undefined' && window.document
      ? window.document.body || window.document.getElementById('root')
      : null;

  useEffect(() => {
    if (typeof window === 'undefined' || !window.document?.body) return undefined;
    if (show) window.document.body.classList.add('modal-open');
    else window.document.body.classList.remove('modal-open');
    return () => window.document.body.classList.remove('modal-open');
  }, [show]);

  useEffect(() => {
    if (!show || typeof window === 'undefined' || !window.document) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') onClose();
    };
    window.document.addEventListener('keydown', onKey);
    return () => window.document.removeEventListener('keydown', onKey);
  }, [show, onClose]);

  if (!show || !selectedDocument || !portalTarget) return null;

  return ReactDOM.createPortal(
    <div
      className="course-exam-modal-overlay member-academy-document-overlay"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="course-exam-modal member-academy-document-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="member-academy-document-title"
      >
        <header className="course-exam-modal__header">
          <div className="course-exam-modal__header-main">
            <p className="course-exam-modal__eyebrow">Academy document</p>
            <h2 id="member-academy-document-title" className="course-exam-modal__title">
              {selectedDocument.label}
            </h2>
          </div>
          <button
            type="button"
            className="course-exam-modal__close"
            onClick={onClose}
            aria-label="Close"
          />
        </header>

        <div className="course-exam-modal__body member-academy-document-modal__body">
          <MemberAcademyDocumentPanel document={selectedDocument} />
        </div>
      </div>
    </div>,
    portalTarget
  );
}
